import { Card, CardContent, CardDescription, CardHeader } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const AvatarSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('flex-start gap-4 py-2', className);

	// Render
	return (
		<Card className={rootClassName}>
			<CardHeader className='aspect-[1/1] rounded-control w-8'>
				<Skeleton className='leading-[inherit]' />
			</CardHeader>
			<CardContent className='w-full'>
				<CardDescription>
					<Skeleton className='w-40' />
				</CardDescription>
			</CardContent>
		</Card>
	);
};

export { AvatarSkeleton };

// Docs:
// https://github.com/dvtng/react-loading-s#readme
